module.exports = __webpack_public_path__ + "static/img/leftCon.663a534.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/government/leftCon.png
// module id = 1wtB
// module chunks = 44